import React from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";

const Pst_It_Solutions_FAQ = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;
  //   const faqData = programData?.faq || [];
  const faqData = [
    {
      id: "01",
      question: "What is PST IT Solutions?",
      answer:
        "PST IT Solutions is an industry-integrated technology training institute dedicated to helping students and professionals build successful careers in Data Engineering, Data Science, Data Analytics, Cloud Computing, and emerging technologies through practical, job-oriented learning.",
    },
    {
      id: "02",
      question: "Who can join your programs?",
      answer:
        "Our programs are designed for fresh graduates, students, working professionals, career switchers, and anyone looking to develop in-demand technology skills and advance their career in the IT industry.",
    },
    {
      id: "03",
      question: "What makes PST IT Solutions different from other training institutes?",
      answer:
        "We focus on practical learning through live projects, hands-on assignments, industry-relevant curriculum, expert mentorship, interview preparation, and career guidance to ensure learners become industry-ready professionals.",
    },
    {
      id: "04",
      question: "Do you provide placement assistance?",
      answer:
        "Yes. We offer comprehensive career support including resume building, mock interviews, LinkedIn profile optimization, career mentoring, and placement assistance to help learners achieve their career goals.",
    },
    {
      id: "05",
      question: "How are the training sessions conducted?",
      answer:
        "Our training programs are delivered through live interactive sessions, practical labs, real-time projects, recorded resources, and continuous mentor support, providing a flexible and engaging learning experience.",
    },

    {
      id: "06",
      question: "Do you have a mobile app for learning?",
      answer:
        "Yes. PST IT Solutions offers a dedicated Android mobile application that allows learners to access course information, study materials, updates, notifications, and career resources anytime, anywhere.",
    },

    {
      id: "07",
      question: "Which technologies do you cover in your programs?",
      answer:
        "Our programs cover industry-demand technologies including Python, SQL, Hadoop, Spark, Kafka, Hive, AWS, Azure, Databricks, Airflow, Power BI, Data Engineering, Data Analytics, and Data Science tools. These FAQs look professional, improve website credibility, and help with SEO on your About Us page.",
    },
  ];
  return (
    <section className="FAQ_div">
      <div className="container">
        <div className="FAQ_header">
          <h5>
            {" "}
            FREQUENTLY <span> ASKED QUESTIONS</span>{" "}
          </h5>
        </div>

        <div className="FAQ_section">
          {faqData.length > 0 ? (
            <Accordion defaultActiveKey="0">
              {faqData.map((item, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={item.id}
                  className="mb-3"
                >
                  <Accordion.Header>
                    <span className="faq_number">{index + 1}</span>{" "}
                    <span className="faq_question">{item.question}</span>
                  </Accordion.Header>
                  <Accordion.Body>{item.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <div className="text-center my-4">
              <p className="text-muted">
                No Frequently Asked Questions Available
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Pst_It_Solutions_FAQ;
